import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerSelectFamiliar = styled(motion.div)`
  width: 100%;
  min-height: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  
  .title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    margin-top: 15px;
    margin-bottom: 20px;
  }
  
  /* Ajustes para pantallas pequeñas */
  @media (max-height: 700px) {
    padding-top: 30px;
    
    .title {
      margin-top: 10px;
      margin-bottom: 15px;
    }
  }
  
  @media (max-height: 600px) {
    padding-top: 10px;
    
    .title {
      margin-top: 8px;
      margin-bottom: 12px;
      font-size: 16px;
    }
  }
`;

export const ButtonOne = styled.button`
  width: 303px;
  height: 76px;
  background: var(--color-secondary-gradient);
  border-radius: 18px;
  color: var(--color-white);
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  padding-left: 30px;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
`;

export const ButtonTwo = styled.button`
  width: 303px;
  height: 48px;
  min-height: 48px;
  background: var(--color-secondary-gradient);
  border-radius: 8px;
  color: var(--color-white);
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 45px;
  .circle {
    color: var(--color-white);
    font-weight: 400;
    font-size: 30px;
    line-height: 150%;
    margin-right: 10px;
  }
`;

export const ContainerAdd = styled.div`
  width: 100%;
  margin-top: 25px;
  height: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: var(--color-primary);
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 40px;
    line-height: 150%;
  }
  
  .subtitle {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
  }
  
  @media (max-height: 700px) {
    margin-top: 15px;
  }
  
  @media (max-height: 600px) {
    margin-top: 10px;
    
    .circle {
      width: 40px;
      height: 40px;
      font-size: 32px;
    }
    
    .subtitle {
      font-size: 16px;
    }
  }
`;


export const ContainerButtons = styled.div`
  width: 98%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 20px;
  
  /* El scroll ahora lo maneja LayoutPasos */
  
  /* Ajustes para pantallas pequeñas */
  @media (max-height: 700px) {
    gap: 14px;
  }
  
  @media (max-height: 600px) {
    gap: 12px;
  }
`;